import {DateHelper} from "~/helpers/dateHelper"

export enum DatetimeMode {
  Date = 0,
  Time = 1,
  Datetime = 2,
}

export let DatetimeModeDisplay: { [key in DatetimeMode]: string } = {
  [DatetimeMode.Date]: 'Just Date',
  [DatetimeMode.Time]: 'Just Time',
  [DatetimeMode.Datetime]: 'Both Date and Time',
};

export function getSubmissionDatetime(mode: DatetimeMode): Date {
  const now = DateHelper.now()
  if (mode === DatetimeMode.Date) {
    return DateHelper.beginningOfDay(now)
  } else {
    return DateHelper.beginningOfMinute(now)
  }
}
